import React from 'react'
import { Container } from '@material-ui/core'
import { Header } from '../../components/shared/Header'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root: {},
    container: {
        marginTop: '1.5rem',
        marginBottom: '6rem',
        [theme.breakpoints.up('sm')]: {
            marginBottom: '0',
        },
    },
}))

export function CenteredLayout({ toolbar, children }) {
    const classes = useStyles()

    return (
        <>
            <Header />
            <div>{toolbar}</div>
            <Container maxWidth='xl' className={classes.container}>
                {children}
            </Container>
        </>
    )
}
